import type { Complaint } from '@/services/complaints'

export const getTicketNumber = (complaint: Complaint) =>
  complaint.ticket_number || complaint.complaint_ref || `#${complaint.id}`

export const getConversationSource = (complaint: Complaint) => {
  if (complaint.email_enabled) return 'Email thread'
  if (complaint.complainant_role === 'worker') return 'Worker portal'
  return 'Portal thread'
}
